// @flow

import React from 'react';
import glamorous from 'glamorous';
import numeral from 'numeral';
import Avatar from 'app/components/commons/Avatar';

type Props = {
  avatar: Object,
  countryFlag?: string,
  name: string,
  score: number,
  winner: boolean,
};

const defaultProps = {
  countryFlag: undefined,
};

const PlaceDiv = glamorous.div({
  marginTop: 20,
  position: 'relative',
  width: '100%',
});

const AvatarWrapper = glamorous.div({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 4,
  position: 'relative',
});

const StyledAvatar = glamorous(Avatar)(({ hasCrown, theme }) => ({
  borderColor: hasCrown ? theme.color.green : '#a5a7a6',
  borderStyle: 'solid',
  borderWidth: 2,
  transform: hasCrown ? 'scale(1.25)' : 'inherit',
}));

const Name = glamorous.div(({ theme }) => ({
  color: theme.color.white,
  fontSize: theme.fontSize.default,
  fontWeight: theme.fontWeight.demiBold,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

const Score = glamorous.span(({ selected, theme }) => ({
  color: selected ? theme.color.green : theme.color.basis6,
  fontSize: theme.fontSize.small,
  fontWeight: selected ? theme.fontWeight.demiBold : theme.fontWeight.normal,
}));

const Details = glamorous.div({
  paddingTop: 10,
  textAlign: 'center',
});

function PlaceSingle({ avatar, countryFlag, name, score, winner }: Props) {
  return (
    <PlaceDiv winner={winner}>
      <AvatarWrapper>
        <StyledAvatar avatar={avatar} countryFlag={countryFlag} hasCrown={winner} size="medium" />
      </AvatarWrapper>
      <Details>
        <Name>{name}</Name>
        <Score selected={winner}>{numeral(score).format('0.00')}</Score>
      </Details>
    </PlaceDiv>
  );
}

PlaceSingle.defaultProps = defaultProps;

export default PlaceSingle;
